import React, { useState } from 'react';
import { Column, Tab } from 'rbx';
import { useStoreState } from 'easy-peasy';
import uuidv4 from 'uuid/v4';
// import swal from 'sweetalert';
import { toast } from 'react-toastify';

import { Tabs, CheckBox } from '../../../components/elements';
import Layout from '../../../components/global/Layout';
import Header from './Header';
import Search from './Search';

import OrderDetailsTable from './OrderDetailsTable';
import OrderSummary from './OrderSummary';
import {
  fetchUserOrderSummary,
  fetchUserOrdersDetails,
  transformUserOrderSummary,
  transformUserOrderDetails,
  downloadCSVFile,
} from './helpers';

const UserOrdersHistory = () => {
  const { userId } = useStoreState(state => state.auth);

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('TAB1');
  const [userOrderSummaryData, setUserOrderSummaryData] = useState([]);
  const [userOrderDetailsData, setUserOrdersDetailsData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [userIdForOrderDetails, setUserIdForOrderDetails] = useState();

  const [placename, setPlacename] = useState('');
  const [username, setUsername] = useState('');
  const [userFullName, setUserFullName] = useState('');
  const [useremail, setUseremail] = useState('');
  const [paymentMethod, setPaymentMethod] = useState({
    label: 'CARD',
    value: 'CARD',
  });
  const [orderRef, setOrderRef] = useState('');
  const [status, setStatus] = useState({
    label: 'COMPLETE',
    value: 'COMPLETE',
  });
  const [service, setService] = useState({ label: 'ALL', value: 'All' });
  const [selectionKey, ,] = useState(uuidv4());
  const [startDate, setStartDate] = useState(
    new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
  );
  const [endDate, setEndDate] = useState(new Date());
  const [dateTimeActive, setDateTimeActive] = React.useState(false);
  const [phone, setPhone] = useState();
  const [counts, setCounts] = useState({ tab1: 0, tab2: 0 });

  const [excludeTestPlace, setExcludeTestPlace] = React.useState(false);
  const [isCashExclude, setIsCashExclude] = React.useState(false);
  const [downloadCsv, setDownloadCsv] = React.useState(false);

  const isTestPlace = !excludeTestPlace;

  const selectUserId = id => {
    setUserIdForOrderDetails(id);
  };

  const canLoadMoreData = currentPage + 1 < totalPages;

  console.log('userOrderSummaryData...', userOrderSummaryData);

  const loadMoreDataFunc = () => {
    setCurrentPage(currentPage + 1);
  };

  const onDownloadCsvTab1 = async () => {
    setDownloadCsv(true);

    function escapeCSVValue(value) {
      if (value === null || value === undefined) return '';

      if (typeof value === 'boolean') return value ? 'true' : 'false';

      const stringValue = String(value);

      if (
        stringValue.includes(',') ||
        stringValue.includes('"') ||
        stringValue.includes('\n')
      ) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    }

    function generateArray(n) {
      return Array.from(Array(n).keys());
    }

    try {
      const firstPageResponse = await fetchUserOrderSummary({
        userId,
        from: 0,
        username,
        useremail,
        phone,
        isTestPlace,
        isCashExclude,
        placename,
        startDate,
        endDate,
        service: service?.value,
        paymentMethod: paymentMethod?.value,
        status: status?.value,
        userFullName,
      });

      if (!firstPageResponse) {
        throw new Error('No response from the api!');
      }

      const totals = firstPageResponse.totalPages || 1;

      let allMenuItems = [...transformUserOrderSummary(firstPageResponse.data)];

      if (totals > 1) {
        const pageIndexes = generateArray(totals).slice(1);
        const remainingPagesResponses = await Promise.all(
          pageIndexes.map(pageIndex =>
            fetchUserOrderSummary({
              userId,
              from: pageIndex * 50,
              username,
              useremail,
              phone,
              isTestPlace,
              isCashExclude,
              placename,
              startDate,
              endDate,
              service: service?.value,
              paymentMethod: paymentMethod?.value,
              status: status?.value,
              userFullName,
            }),
          ),
        );

        const remainingItems = remainingPagesResponses.flatMap(response =>
          transformUserOrderSummary(response.data),
        );

        allMenuItems = [...allMenuItems, ...remainingItems];
      }

      if (allMenuItems.length === 0) {
        throw new Error('No data available');
      }
      const headers = Object.keys(allMenuItems[0]);
      const headerRow = headers.map(escapeCSVValue).join(',');

      const dataRows = allMenuItems.map(item =>
        headers.map(header => escapeCSVValue(item[header])).join(','),
      );

      const csvContent = [headerRow, ...dataRows].join('\n');

      downloadCSVFile(
        csvContent,
        `user-order-summary-${new Date().toISOString()}.csv`,
      );
    } catch (error) {
      toast.error(
        `Failed to download CSV: ${error.message || 'Unknown error'}`,
      );
    } finally {
      setDownloadCsv(false);
    }
  };

  const onDownloadCsvTab2 = async () => {
    setDownloadCsv(true);

    function escapeCSVValue(value) {
      if (value === null || value === undefined) return '';

      if (typeof value === 'boolean') return value ? 'true' : 'false';

      const stringValue = String(value);

      if (
        stringValue.includes(',') ||
        stringValue.includes('"') ||
        stringValue.includes('\n')
      ) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    }

    function generateArray(n) {
      return Array.from(Array(n).keys());
    }

    try {
      const firstPageResponse = await fetchUserOrdersDetails({
        userId: userIdForOrderDetails,
        adminUserId: userId,
        from: 0,
        placename,
        orderRef,
        paymentMethod: paymentMethod?.value,
        status: status?.value,
        service: service?.value,
        startDate,
        endDate,
        isTestPlace,
        isCashExclude,
        phone,
      });

      if (!firstPageResponse) {
        throw new Error('No response from the api!');
      }

      const totals = firstPageResponse.totalPages || 1;

      let allMenuItems = [...transformUserOrderDetails(firstPageResponse.data)];

      if (totals > 1) {
        const pageIndexes = generateArray(totals).slice(1);
        const remainingPagesResponses = await Promise.all(
          pageIndexes.map(pageIndex =>
            fetchUserOrdersDetails({
              userId: userIdForOrderDetails,
              adminUserId: userId,
              from: pageIndex * 50,
              placename,
              orderRef,
              paymentMethod: paymentMethod?.value,
              status: status?.value,
              service: service?.value,
              startDate,
              endDate,
              isTestPlace,
              isCashExclude,
              phone,
            }),
          ),
        );

        const remainingItems = remainingPagesResponses.flatMap(response =>
          transformUserOrderDetails(response.data),
        );

        allMenuItems = [...allMenuItems, ...remainingItems];
      }

      if (allMenuItems.length === 0) {
        throw new Error('No data available');
      }
      const headers = Object.keys(allMenuItems[0]);
      const headerRow = headers.map(escapeCSVValue).join(',');

      const dataRows = allMenuItems.map(item =>
        headers.map(header => escapeCSVValue(item[header])).join(','),
      );

      const csvContent = [headerRow, ...dataRows].join('\n');

      downloadCSVFile(
        csvContent,
        `user-order-details-${new Date().toISOString()}.csv`,
      );
    } catch (error) {
      toast.error(
        `Failed to download CSV: ${error.message || 'Unknown error'}`,
      );
    } finally {
      setDownloadCsv(false);
    }
  };

  React.useEffect(() => {
    let ignore = false;
    const fetchTab1Data = async () => {
      setLoading(true);
      const response = await fetchUserOrderSummary({
        userId,
        from: currentPage * 50,
        username,
        useremail,
        phone,
        isTestPlace,
        isCashExclude,
        placename,
        startDate,
        endDate,
        service: service?.value,
        paymentMethod: paymentMethod?.value,
        status: status?.value,
        userFullName,
      });
      if (!ignore && response && currentPage === 0) {
        setUserOrderSummaryData(transformUserOrderSummary(response.data));
        setTotalPages(response.totalPages);
        setCounts(prev => ({ ...prev, tab1: response.totalSize }));
      } else if (!ignore && response) {
        setUserOrderSummaryData([
          ...userOrderSummaryData,
          ...transformUserOrderSummary(response.data),
        ]);
      }
      setLoading(false);
    };

    const fetchTab2Data = async () => {
      setLoading(true);
      const response = await fetchUserOrdersDetails({
        userId: userIdForOrderDetails,
        adminUserId: userId,
        from: currentPage * 50,
        placename,
        orderRef,
        paymentMethod: paymentMethod?.value,
        status: status?.value,
        service: service?.value,
        startDate,
        endDate,
        isTestPlace,
        isCashExclude,
        phone,
      });
      if (!ignore && response && currentPage === 0) {
        setUserOrdersDetailsData(transformUserOrderDetails(response.data));
        setTotalPages(response.totalPages);
        setCounts(prev => ({ ...prev, tab2: response.totalSize }));
      } else if (!ignore && response) {
        setUserOrdersDetailsData([
          ...userOrderDetailsData,
          ...transformUserOrderDetails(response.data),
        ]);
      }
      setLoading(false);
    };

    if (activeTab === 'TAB1') {
      fetchTab1Data();
    }

    if (activeTab === 'TAB2') {
      fetchTab2Data();
    }

    return () => {
      ignore = true;
    };
  }, [
    userId,
    activeTab,
    currentPage,
    userIdForOrderDetails,
    username,
    useremail,
    placename,
    orderRef,
    paymentMethod?.value,
    status?.value,
    service?.value,
    startDate,
    endDate,
    phone,
    isTestPlace,
    isCashExclude,
    userFullName,
  ]);

  React.useEffect(() => {
    // setPlacename('');
    // setUsername('');
    // setUseremail('');
    // setPaymentMethod();
    // setOrderRef('');
    // setStatus();
    // setService();
    // setSelectionKey(uuidv4());
    // setDateTimeActive(false);
  }, [activeTab]);

  React.useEffect(() => {
    setCurrentPage(0);
    setTotalPages(0);
  }, [
    placename,
    username,
    useremail,
    paymentMethod,
    orderRef,
    status,
    service,
    startDate,
    endDate,
  ]);

  return (
    <Layout>
      <Header />

      <Column.Group
        style={{ padding: '1rem 1rem 0 1rem' }}
        vcentered
        multiline
        gapSize={8}
      >
        <Column size={3}>
          <CheckBox
            label="Exclude Test Restaurants"
            value={excludeTestPlace}
            onChange={value => {
              setExcludeTestPlace(value);
            }}
          />
        </Column>
        <Column size={3}>
          <CheckBox
            label="Exclude Cash Orders"
            name="event_business"
            value={isCashExclude}
            onChange={value => {
              setIsCashExclude(value);
            }}
          />
        </Column>
      </Column.Group>

      <Search
        phone={phone}
        setPhone={setPhone}
        selectionKey={selectionKey}
        refetchData={() => {}}
        endDate={endDate}
        setEndDate={setEndDate}
        startDate={startDate}
        setStartDate={setStartDate}
        placename={placename}
        username={username}
        useremail={useremail}
        paymentMethod={paymentMethod}
        orderRef={orderRef}
        status={status}
        service={service}
        userFullName={userFullName}
        onUserFullNameChange={v => setUserFullName(v)}
        disabledForActiveTab1={activeTab === 'TAB1'}
        disabledForActiveTab2={activeTab === 'TAB2'}
        onPlacenameChange={v => setPlacename(v)}
        onUsernameChange={v => setUsername(v)}
        onUseremailChange={v => setUseremail(v)}
        onPaymentMethodChange={v => setPaymentMethod(v)}
        onOrderRefChange={v => setOrderRef(v)}
        onStatusChange={v => setStatus(v)}
        onServiceChange={v => setService(v)}
        setDateTimeActive={setDateTimeActive}
        dateTimeActive={dateTimeActive}
      />
      <div style={{ position: 'absolute', right: 0 }}>
        <button
          className={`${downloadCsv &&
            'is-loading'} button is-primary is-outlined`}
          style={{ margin: '5px' }}
          onClick={async () => {
            if (activeTab === 'TAB1') {
              await onDownloadCsvTab1();
            } else {
              await onDownloadCsvTab2();
            }
          }}
        >
          Download CSV
        </button>
      </div>
      <Tabs className="tabs is-medium is-fullwidth">
        <Tab
          onClick={() => {
            setActiveTab('TAB1');
            setTotalPages(0);
            setCurrentPage(0);

            setUserOrderSummaryData([]);
            setUserOrdersDetailsData([]);

            selectUserId(null);

            setCounts(prev => ({ ...prev, tab2: 0 }));
          }}
          active={activeTab === 'TAB1'}
          style={{ cursor: activeTab === 'TAB1' ? 'text' : 'pointer' }}
        >
          Order Summary {counts.tab1 === 0 ? '' : `(${counts.tab1})`}
        </Tab>
        <Tab
          onClick={() => {
            if (activeTab === 'TAB1') {
              setActiveTab('TAB2');
              setTotalPages(0);
              setCurrentPage(0);
              setUserOrderSummaryData([]);
              setUserOrdersDetailsData([]);
            }
          }}
          active={activeTab === 'TAB2'}
          style={{ cursor: activeTab === 'TAB2' ? 'text' : 'pointer' }}
        >
          Order Details {counts.tab2 === 0 ? '' : `(${counts.tab2})`}
        </Tab>
      </Tabs>
      {loading && (
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0.5rem',
          }}
        >
          Loading...
        </span>
      )}
      {activeTab === 'TAB1' && (
        <OrderSummary
          loading={loading}
          userOrderSummaryData={userOrderSummaryData}
          canLoadMoreData={canLoadMoreData}
          loadMoreData={loadMoreDataFunc}
          selectUserId={selectUserId}
          changeTab={() => {
            setActiveTab('TAB2');
            setTotalPages(0);
            setCurrentPage(0);
            setUserOrderSummaryData([]);
            setUserOrdersDetailsData([]);
          }}
        />
      )}
      {activeTab === 'TAB2' && (
        <OrderDetailsTable
          loading={loading}
          userOrderDetailsData={userOrderDetailsData}
          canLoadMoreData={canLoadMoreData}
          loadMoreData={loadMoreDataFunc}
        />
      )}
    </Layout>
  );
};

export default UserOrdersHistory;
